<script setup lang="ts">
import brandIconUrl from '../../../assets/brand/app-icon-red-note-chat.png'

withDefaults(
  defineProps<{
    compact?: boolean
    inverse?: boolean
  }>(),
  {
    compact: false,
    inverse: false,
  },
)
</script>

<template>
  <span class="brand-logo" :class="{ 'brand-logo--inverse': inverse }">
    <img class="brand-logo__mark" :src="brandIconUrl" alt="" aria-hidden="true" />
    <strong v-if="!compact">发多多</strong>
  </span>
</template>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: var(--ml-text-primary);
  font-size: 22px;
  line-height: 1;
  white-space: nowrap;
}

.brand-logo--inverse {
  color: #fff;
}

.brand-logo__mark {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 11px;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(244, 16, 56, 0.24);
}
</style>
